{
  "id": "b1-vocabulary-02",
  "name": "B1 Frequency Band 2 (51-100)",
  "description": "B1 level French frequency vocabulary",
  "examGrade": "B1",
  "difficulty": "intermediate",
  "source": "French subtitle frequency list",
  "sourceUrl": "https://github.com/hermitdave/FrequencyWords",
  "category": "general",
  "words": [
    {
      "id": "fr:vocab:1552:soldats",
      "word": "soldats",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14724
    },
    {
      "id": "fr:vocab:1553:amuser",
      "word": "amuser",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14720
    },
    {
      "id": "fr:vocab:1554:points",
      "word": "points",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14710
    },
    {
      "id": "fr:vocab:1555:suivi",
      "word": "suivi",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14703
    },
    {
      "id": "fr:vocab:1556:oubliez",
      "word": "oubliez",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14695
    },
    {
      "id": "fr:vocab:1557:langue",
      "word": "langue",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14649
    },
    {
      "id": "fr:vocab:1558:direction",
      "word": "direction",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14616
    },
    {
      "id": "fr:vocab:1559:frais",
      "word": "frais",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14610
    },
    {
      "id": "fr:vocab:1560:veuillez",
      "word": "veuillez",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14609
    },
    {
      "id": "fr:vocab:1561:miss",
      "word": "miss",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14594
    },
    {
      "id": "fr:vocab:1562:soldat",
      "word": "soldat",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14572
    },
    {
      "id": "fr:vocab:1563:couleur",
      "word": "couleur",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14567
    },
    {
      "id": "fr:vocab:1564:bouger",
      "word": "bouger",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14561
    },
    {
      "id": "fr:vocab:1565:frapp",
      "word": "frappé",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14549
    },
    {
      "id": "fr:vocab:1566:frapper",
      "word": "frapper",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14537
    },
    {
      "id": "fr:vocab:1567:venait",
      "word": "venait",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14533
    },
    {
      "id": "fr:vocab:1568:rat",
      "word": "raté",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14530
    },
    {
      "id": "fr:vocab:1569:videmment",
      "word": "évidemment",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14516
    },
    {
      "id": "fr:vocab:1570:sacr",
      "word": "sacré",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14485
    },
    {
      "id": "fr:vocab:1571:cl-s",
      "word": "clés",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14470
    },
    {
      "id": "fr:vocab:1572:mentir",
      "word": "mentir",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14455
    },
    {
      "id": "fr:vocab:1573:pouse",
      "word": "épouse",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14418
    },
    {
      "id": "fr:vocab:1574:troisi-me",
      "word": "troisième",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14405
    },
    {
      "id": "fr:vocab:1575:johnny",
      "word": "johnny",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14375
    },
    {
      "id": "fr:vocab:1576:amy",
      "word": "amy",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14372
    },
    {
      "id": "fr:vocab:1577:j-sus",
      "word": "jésus",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14329
    },
    {
      "id": "fr:vocab:1578:faible",
      "word": "faible",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14327
    },
    {
      "id": "fr:vocab:1579:ryan",
      "word": "ryan",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14316
    },
    {
      "id": "fr:vocab:1580:afin",
      "word": "afin",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14300
    },
    {
      "id": "fr:vocab:1581:bleu",
      "word": "bleu",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14265
    },
    {
      "id": "fr:vocab:1582:failli",
      "word": "failli",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14256
    },
    {
      "id": "fr:vocab:1583:courir",
      "word": "courir",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14252
    },
    {
      "id": "fr:vocab:1584:am-ricain",
      "word": "américain",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14245
    },
    {
      "id": "fr:vocab:1585:d-tails",
      "word": "détails",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14215
    },
    {
      "id": "fr:vocab:1586:pont",
      "word": "pont",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14160
    },
    {
      "id": "fr:vocab:1587:gay",
      "word": "gay",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14151
    },
    {
      "id": "fr:vocab:1588:regarde-moi",
      "word": "regarde-moi",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14151
    },
    {
      "id": "fr:vocab:1589:jake",
      "word": "jake",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14103
    },
    {
      "id": "fr:vocab:1590:billy",
      "word": "billy",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14103
    },
    {
      "id": "fr:vocab:1591:attraper",
      "word": "attraper",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14102
    },
    {
      "id": "fr:vocab:1592:papiers",
      "word": "papiers",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14099
    },
    {
      "id": "fr:vocab:1593:poisson",
      "word": "poisson",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14098
    },
    {
      "id": "fr:vocab:1594:lui-m-me",
      "word": "lui-même",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14094
    },
    {
      "id": "fr:vocab:1595:wow",
      "word": "wow",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14088
    },
    {
      "id": "fr:vocab:1596:chiens",
      "word": "chiens",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14064
    },
    {
      "id": "fr:vocab:1597:date",
      "word": "date",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14059
    },
    {
      "id": "fr:vocab:1598:intention",
      "word": "intention",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14048
    },
    {
      "id": "fr:vocab:1599:procureur",
      "word": "procureur",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14043
    },
    {
      "id": "fr:vocab:1600:go-t",
      "word": "goût",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14034
    },
    {
      "id": "fr:vocab:1601:pourras",
      "word": "pourras",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B1",
      "frequency": 14032
    }
  ]
}